'use strict';

angular.module('internal.admin')
    .directive('internalAdminEnterpriseNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'admin/components/admin-enterprise-navigation/admin-enterprise-navigation.html',
            replace: true,
            controller: ('internalAdminEnterpriseNavigation', ['$scope', '$state', '$window', '$rootScope', function ($scope, $state, $window, $rootScope) {
                $scope.navigationChange = function (record) {
                    //Check whether this is CF page or angular/react page
                    var angularURL = $state.href(record.state);
                    if (angularURL != null) {
                        $state.go(record.state);
                    }
                    else {
                        $window.location.href = $rootScope.internalURL + "license/" + record.address;
                    }
                }
                $scope.navigationParameters = {
                    state: "internal.admin.enterprise",
                    objectGroup: "Farm"
                }
            }])
        };
    }])
;